module.exports = __webpack_public_path__ + "img/multiplier_free_4.82d1a757.png";